import {createI18n} from 'vue-i18n'
import fr from '@/i18n/fr'
import en from '@/i18n/en'

const allowTrucatPrefixes = ['entity.lineId.venues']

const i18n = createI18n({
  locale: 'fr',
  fallbackLocale: 'fr',
  missing(locale, key) {
    const prefix = key.substring(0, key.lastIndexOf('.'))
    if(allowTrucatPrefixes.includes(prefix)) {
      return key.split('.').at(-1);
    }else {
      return key;
    }
  },
  messages: {
    fr: fr,
    en: en
  },
  silentTranslationWarn: true
})
export default i18n
